const memberPortalRoutes = {
  home: "/home",
  notes: "/home/notes",
  give: "/give",
};

export { memberPortalRoutes };
